import { render, staticRenderFns } from "./JobReminderCriterionList.vue?vue&type=template&id=63c38192&"
import script from "./JobReminderCriterionList.vue?vue&type=script&lang=js&"
export * from "./JobReminderCriterionList.vue?vue&type=script&lang=js&"
import style0 from "./JobReminderCriterionList.vue?vue&type=style&index=0&id=63c38192&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports